:host {
  --top-padding: calc(var(--spacer) * 3);
  --font-family: var(--font-family-secondary);
  --hover-color: var(--blue-layout-301-active);
}

.bb-target {
  &.bb-defocused {
    opacity: 0.7 !important;
  }
}

.loading-container {
  padding-top: calc(var(--spacer) * 13);
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  gap: calc(var(--spacer) * 3);

  &-small-size {
    display: flex;
    padding-top: calc(var(--spacer) * 11);
    flex-flow: column;
    gap: calc(var(--spacer) * 12);
  }
}

.main-container {
  padding-top: var(--top-padding);
  width: 100%;
  --chart-size: 160px;

  .section-content {
    display: flex;
    flex-flow: row;
    justify-content: flex-start;
    align-items: center;
    min-height: var(--chart-size);
    gap: calc(var(--spacer) * 3);

    .chart-wrapper {
      position: relative;
      width: fit-content;
      height: fit-content;

      .chart-central-info {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 50%;
        left: 50%;
        max-width: calc(75% - 20px);
        transform: translate(-50%, -50%);
        z-index: 1;

        .central-label {
          width: 100%;
        }

        gz-text {
          line-height: 1;
          width: fit-content;
          display: inline;
          color: var(--main-titles-inputs-600);
          --font-family: 'Montserrat', sans-serif;
        }
      }

      .chart-central-info-text-multiline {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 50%;
        left: 50%;
        max-width: calc(75% - 20px);
        transform: translate(-50%, -50%);
        z-index: 1;

        .central-label {
          width: 100%;
          text-align: center;
          word-wrap: break-word;
          overflow-wrap: break-word; /* Fallback for older browsers */
        }

        gz-text {
          line-height: 1;
          width: fit-content;
          display: inline;
          text-align: center;
          white-space: normal;
          --font-family: 'Montserrat', sans-serif;
        }
      }

      #chart-container {
        min-width: var(--chart-size);
        width: var(--chart-size);
        height: var(--chart-size);
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 5px;
      }
    }

    .chart-legend-container {
      align-items: center;
      justify-content: flex-start;
      display: flex;
      max-width: 320px;
      min-width: 0;

      .chart-legend {
        display: flex;
        flex-flow: column;
        padding: 0 var(--spacer);
        min-width: 0;

        .chart-legend-item {
          display: flex;
          align-items: center;
          gap: var(--spacer);
          min-height: 32px;
          cursor: default;

          .chart-legend {
            flex: 1 1 0;
            display: flex;
            justify-content: space-between;
            gap: calc(var(--spacer) * 4);
            min-width: 0;
            flex-flow: row;
            color: var(--main-titles-inputs-600);

            .chart-legend-value {
              font-weight: bold;
              font-family: var(--font-family-secondary-mono);
            }
          }

          .chart-legend-bullet {
            width: 10px;
            height: 10px;
          }
        }
      }
    }
    .chart-legend-container .chart-legend .clickable:hover {
      color: var(--hover-color);
      cursor: pointer;
    }
  }

  &.small-size {
    padding-top: calc(var(--spacer) * 2.5);

    .section-content {
      flex-flow: column;
      align-items: flex-start;

      .chart-legend-container {
        width: 100%;
      }
    }
  }
}

:host([chartStyle='risk-management']) {
  .main-container {
    .section-content {
      .chart-legend-container {
        max-width: 100%;
        flex-grow: 1;

        .chart-legend {
          padding: 0;
          max-width: 100%;
          flex-grow: 1;

          .chart-legend-item {
            border-bottom: 1px solid var(--chart-101-pressed-dividers);
          }
        }
      }
    }

    &.small-size {
      padding-top: 0;

      .section-content {
        align-items: center;
        gap: var(--spacer);
      }
    }
  }

  .loading-container {
    &-small-size {
      padding-top: 0;
      gap: 0;
    }
  }
}

.chart-tooltip {
  font-size: var(--tooltip-font-size);
  font-family: var(--font-family-secondary);
  color: var(--main-titles-inputs-600);
  background-color: var(--white-layout-303-level-2-elevation);
  box-shadow: 0px 0px 6px 0px var(--chart-050-hover);
  border-radius: calc(var(--spacer) * 0.5);
  padding: var(--spacer) calc(var(--spacer) * 1.5);
  position: absolute;
  z-index: 2;
  transform: translateY(35%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacer);
}

:host([horizontalTooltip]) {
  .chart-tooltip {
    flex-direction: row;

    .chart-legend-bullet {
      width: 10px;
      height: 10px;
    }

    .chart-legend {
      flex: 1 1 0;
      display: flex;
      justify-content: space-between;
      gap: calc(var(--spacer) * 4);
      min-width: 0;
      flex-flow: row;
      color: var(--main-titles-inputs-600);

      .chart-legend-value {
        font-weight: bold;
        font-family: var(--font-family-secondary-mono);
      }
    }
  }
}
